import { HandPointUp } from "@gravity-ui/icons";
import { Card, Flex, Icon, Text } from "@gravity-ui/uikit";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import { useProductInfoTranslate } from "./hooks";
import css from "./ProductInfoCard.module.scss";

interface ProductInfoCardProps {
  price?: number;
  currency?: string;
  delivery?: {
    min: number | null;
    max: number | null;
  };
  deliveryBlur?: string;
  isLoading: boolean;
  isBlur: boolean;
  promptText?: string;
}

export const ProductInfoCard = ({
  price,
  currency,
  delivery,
  deliveryBlur,
  isLoading,
  isBlur,
  promptText,
}: ProductInfoCardProps) => {
  const translations = useProductInfoTranslate();
  const deliveryText = isBlur
    ? deliveryBlur
    : delivery && (delivery?.min || delivery?.max)
      ? `${delivery.min ?? "?"}-${delivery.max ?? "?"} дней`
      : "—";

  return (
    <Card
      className={cn(css.mainInfoHeader, {
        [css.promptCard]: promptText,
      })}
      view="outlined"
      type="action"
      size="l"
    >
      <Flex direction="column" gap="2">
        {!isLoading ? (
          promptText ? (
            <Flex alignItems="center" gap="2" className={css.promptHint}>
              <Icon data={HandPointUp} size={20} />
              <Text>{promptText}</Text>
            </Flex>
          ) : (
            <>
              <Text
                variant="subheader-3"
                className={cn(css.price, { [css.blur]: isBlur })}
              >
                {translations.cost}:{" "}
                {price ? `${price} ${currency ?? ""}` : "—"}
              </Text>

              <Text
                variant="subheader-2"
                color="secondary"
                className={cn(css.price, { [css.blur]: isBlur })}
              >
                {translations.delivery}: {deliveryText}
              </Text>
            </>
          )
        ) : (
          <>
            <Skeleton width="max" height={24} className={css.skeletonCard} />
            <Skeleton width="max" height={20} className={css.skeletonCard} />
          </>
        )}
      </Flex>
    </Card>
  );
};
